import { render, staticRenderFns } from "./contactMe.vue?vue&type=template&id=af56a308&"
import script from "./contactMe.vue?vue&type=script&lang=js&"
export * from "./contactMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports